import {
    ICurrencyData, IModalData, IPlatformInfoData, ITravelData, ITravelFilterData, IModalInitData, IOrderData, ITravel,
} from '../../entities'
import {
    ICurrencyMutations, IModalMutations, IRequestMutations,
    IState,
    Theme
} from '../index'
import {
    IMutations
} from './index'

export const currencyMutations: ICurrencyMutations = {
    fetchCurrencies(state: IState, payload: ICurrencyData[]) {
        state.currencies = payload
    },
    setCurrency(state: IState, payload: ICurrencyData) {
        state.currency = payload
    }
}

export const modalMutations: IModalMutations = {
    // setModal(state: IState, payload?: IModalData) {
    //     state.modal = payload
    // }
    setModal(state: IState, payload?: IModalInitData) {
        state.modal = payload;
    }
}

export const requestMutations: IRequestMutations = {
    setOrder(state: IState, payload: IOrderData) {
        state.order = payload
    }
}

export const styleMutations: any  = {
    setCheckboxLabelColor(state: IState, payload:boolean): any {
        state.checkboxLabelCol = payload;
    }
}

export const groupTravelMutations: any = {
    setGroupTravel(state: IState, payload: ITravel): any {
        state.groupTravel = payload;
    }
}

export const emailModalMutation: any = {
    setEmailModalCondition(state: IState, payload: boolean) {
        state.isShowEmailFormActive = payload;
    }
}

const travelFormatRequestMutations: any = {
    setTravelFormatRequest(state: IState, payload: string): void {
        state.travelFormatRequest = payload;
    }
}

export const mutations: IMutations = {

    ...currencyMutations,
    ...modalMutations,
    ...requestMutations,
    ...styleMutations,
    ...groupTravelMutations,
    ...emailModalMutation,
    ...travelFormatRequestMutations,

    setPlatformInfo(state:IState, payload: IPlatformInfoData) {
        state.platform = payload
    },
    setLoading(state: IState, payload: boolean) {
        state.loading = payload
    },
    setTheming(state: IState, payload: boolean) {
        state.theming = payload
    },
    setTheme(state: IState, payload: Theme) {
        state.theme = payload
    },
    setTravel(state: IState, payload: ITravelData) {
        state.travel = payload
    },
    setFilters(state: IState, payload: ITravelFilterData) {
        state.filters = payload
    }
}
